<router-outlet />

<app-confirmation />
<app-http-loading />

@if (isBrowserContext) {
  <app-toast />
}
